// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/usr/src/app/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: '.umi__plugin-layout__Layout' */'/usr/src/app/src/.umi/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/~demos/:uuid",
        "layout": false,
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'../dumi/layout'), loading: LoadingComponent})],
        "component": ((props) => dynamic({
          loader: async () => {
            const React = await import('react');
            const { default: getDemoRenderArgs } = await import(/* webpackChunkName: 'dumi_demos' */ '/usr/src/app/node_modules/@umijs/preset-dumi/lib/plugins/features/demo/getDemoRenderArgs');
            const { default: Previewer } = await import(/* webpackChunkName: 'dumi_demos' */ 'dumi-theme-default/es/builtins/Previewer.js');
            const { usePrefersColor, context } = await import(/* webpackChunkName: 'dumi_demos' */ 'dumi/theme');

            return props => {
              
      const { demos } = React.useContext(context);
      const [renderArgs, setRenderArgs] = React.useState([]);

      // update render args when props changed
      React.useLayoutEffect(() => {
        setRenderArgs(getDemoRenderArgs(props, demos));
      }, [props.match.params.uuid, props.location.query.wrapper, props.location.query.capture]);

      // for listen prefers-color-schema media change in demo single route
      usePrefersColor();

      switch (renderArgs.length) {
        case 1:
          // render demo directly
          return renderArgs[0];

        case 2:
          // render demo with previewer
          return React.createElement(
            Previewer,
            renderArgs[0],
            renderArgs[1],
          );

        default:
          return `Demo ${props.match.params.uuid} not found :(`;
      }
    
            }
          },
          loading: () => null,
        }))()
      },
      {
        "path": "/_demos/:uuid",
        "redirect": "/~demos/:uuid"
      },
      {
        "__dumiRoot": true,
        "layout": false,
        "path": "/~docs",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'../dumi/layout'), loading: LoadingComponent}), dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'/usr/src/app/node_modules/dumi-theme-default/es/layout.js'), loading: LoadingComponent})],
        "routes": [
          {
            "path": "/~docs",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'README.md' */'/usr/src/app/README.md'), loading: LoadingComponent}),
            "exact": true,
            "meta": {
              "locale": "en-US",
              "order": null,
              "filePath": "README.md",
              "updatedTime": 1766948727088,
              "slugs": [
                {
                  "depth": 1,
                  "value": "Socialkids",
                  "heading": "socialkids"
                },
                {
                  "depth": 2,
                  "value": "Environment Prepare",
                  "heading": "environment-prepare"
                },
                {
                  "depth": 2,
                  "value": "Provided Scripts",
                  "heading": "provided-scripts"
                },
                {
                  "depth": 3,
                  "value": "Start project",
                  "heading": "start-project"
                },
                {
                  "depth": 3,
                  "value": "Build project",
                  "heading": "build-project"
                },
                {
                  "depth": 3,
                  "value": "Check code style",
                  "heading": "check-code-style"
                },
                {
                  "depth": 3,
                  "value": "Test code",
                  "heading": "test-code"
                },
                {
                  "depth": 3,
                  "value": "Deploy product",
                  "heading": "deploy-product"
                },
                {
                  "depth": 2,
                  "value": "File constructor",
                  "heading": "file-constructor"
                },
                {
                  "depth": 3,
                  "value": "Config api",
                  "heading": "config-api"
                },
                {
                  "depth": 3,
                  "value": "Config router,theme,...",
                  "heading": "config-routertheme"
                },
                {
                  "depth": 3,
                  "value": "Common components",
                  "heading": "common-components"
                },
                {
                  "depth": 3,
                  "value": "Call api",
                  "heading": "call-api"
                },
                {
                  "depth": 3,
                  "value": "Modal global state",
                  "heading": "modal-global-state"
                },
                {
                  "depth": 3,
                  "value": "Page",
                  "heading": "page"
                },
                {
                  "depth": 2,
                  "value": "More",
                  "heading": "more"
                }
              ],
              "title": "Socialkids"
            },
            "title": "Socialkids"
          },
          {
            "path": "/~docs/components",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__index.md' */'/usr/src/app/src/components/index.md'), loading: LoadingComponent}),
            "exact": true,
            "meta": {
              "filePath": "src/components/index.md",
              "updatedTime": 1766948558731,
              "title": "业务组件",
              "sidemenu": false,
              "slugs": [
                {
                  "depth": 1,
                  "value": "业务组件",
                  "heading": "业务组件"
                },
                {
                  "depth": 2,
                  "value": "Footer 页脚组件",
                  "heading": "footer-页脚组件"
                },
                {
                  "depth": 2,
                  "value": "HeaderDropdown 头部下拉列表",
                  "heading": "headerdropdown-头部下拉列表"
                },
                {
                  "depth": 2,
                  "value": "HeaderSearch 头部搜索框",
                  "heading": "headersearch-头部搜索框"
                },
                {
                  "depth": 3,
                  "value": "API",
                  "heading": "api"
                },
                {
                  "depth": 2,
                  "value": "NoticeIcon 通知工具",
                  "heading": "noticeicon-通知工具"
                },
                {
                  "depth": 3,
                  "value": "NoticeIcon API",
                  "heading": "noticeicon-api"
                },
                {
                  "depth": 3,
                  "value": "NoticeIcon.Tab API",
                  "heading": "noticeicontab-api"
                },
                {
                  "depth": 3,
                  "value": "NoticeIconData",
                  "heading": "noticeicondata"
                },
                {
                  "depth": 2,
                  "value": "RightContent",
                  "heading": "rightcontent"
                }
              ],
              "hasPreviewer": true,
              "group": {
                "path": "/~docs/components",
                "title": "Components"
              }
            },
            "title": "业务组件 - ant-design-pro"
          }
        ],
        "title": "ant-design-pro",
        "component": (props) => props.children
      },
      {
        "path": "/user",
        "layout": false,
        "routes": [
          {
            "path": "/user/login",
            "layout": false,
            "name": "login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__Login' */'/usr/src/app/src/pages/user/Login'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "login",
            "path": "/user/autologin",
            "layout": false,
            "hideInMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__AutoLogin' */'/usr/src/app/src/pages/user/AutoLogin'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/user",
            "redirect": "/user/login",
            "exact": true
          },
          {
            "name": "register-result",
            "icon": "smile",
            "path": "/user/register-result",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__register-result' */'/usr/src/app/src/pages/user/register-result'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "register",
            "icon": "smile",
            "path": "/user/register",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__AccountRegister' */'/usr/src/app/src/pages/user/AccountRegister'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "forgetAcc",
            "icon": "smile",
            "path": "/user/forgetAcc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__ForgetAcc' */'/usr/src/app/src/pages/user/ForgetAcc'), loading: LoadingComponent}),
            "layout": false,
            "hideInMenu": true,
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/usr/src/app/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "hideInMenu": true,
        "name": "account",
        "icon": "user",
        "path": "/account",
        "routes": [
          {
            "name": "center",
            "icon": "smile",
            "path": "/account/center",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__account__center' */'/usr/src/app/src/pages/account/center'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "settings",
            "icon": "smile",
            "path": "/account/settings",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__account__settings' */'/usr/src/app/src/pages/account/settings'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/dashboard",
        "name": "Dashboard",
        "icon": "LineChartOutlined",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NoiBo' */'/usr/src/app/src/pages/NoiBo'), loading: LoadingComponent}),
        "access": "routeFilter",
        "maChucNang": "DASHBOARD",
        "exact": true
      },
      {
        "path": "/landing",
        "name": "Giới thiệu",
        "icon": "project",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__AutoLogin__loginlanding' */'/usr/src/app/src/pages/user/AutoLogin/loginlanding'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/index.html",
        "exact": true,
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WelcomePage' */'/usr/src/app/src/pages/WelcomePage'), loading: LoadingComponent})
      },
      {
        "path": "/",
        "exact": true,
        "hideInMenu": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WelcomePage' */'/usr/src/app/src/pages/WelcomePage'), loading: LoadingComponent})
      },
      {
        "name": "Truong",
        "icon": "bank",
        "path": "/truong",
        "access": "routeFilter",
        "maChucNang": "TRUONG",
        "routes": [
          {
            "name": "ThongTinTruong",
            "path": "/truong/thongtintruong",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTruong__components__TruongGiaoVien' */'/usr/src/app/src/pages/QuanLyTruong/components/TruongGiaoVien'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "THONG_TIN_TRUONG",
            "exact": true
          }
        ]
      },
      {
        "name": "QuanLyTruong",
        "icon": "bank",
        "path": "/quanlytruong",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTruong' */'/usr/src/app/src/pages/QuanLyTruong'), loading: LoadingComponent}),
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_TRUONG",
        "exact": true
      },
      {
        "name": "QuanLyLop",
        "icon": "home",
        "path": "/quanlylop",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyLop' */'/usr/src/app/src/pages/QuanLyLop'), loading: LoadingComponent}),
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_LOP",
        "exact": true
      },
      {
        "hideInMenu": true,
        "exact": true,
        "path": "/quanlylop/:id",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyLop__$id' */'/usr/src/app/src/pages/QuanLyLop/$id'), loading: LoadingComponent}),
        "access": "routeFilter",
        "maChucNang": "CHI_TIET_LOP"
      },
      {
        "name": "QuanLyTrongMuon",
        "icon": "ClockCircleOutlined",
        "path": "/quanlytrongmuon",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTrongMuon' */'/usr/src/app/src/pages/QuanLyTrongMuon'), loading: LoadingComponent}),
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_TRONG_MUON",
        "exact": true
      },
      {
        "name": "QuangCao",
        "path": "/quanlytin",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuangCao' */'/usr/src/app/src/pages/QuangCao'), loading: LoadingComponent}),
        "access": "routeFilter",
        "icon": "HighlightOutlined",
        "maChucNang": "QUANG_CAO",
        "exact": true
      },
      {
        "name": "QuanLyTuongTac",
        "icon": "UserSwitchOutlined",
        "path": "/quanlytuongtac",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_TUONG_TAC",
        "routes": [
          {
            "name": "QuanLyTinTuc",
            "path": "/quanlytuongtac/quanlytintuc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TinTucMamNon' */'/usr/src/app/src/pages/TinTucMamNon'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "QUAN_LY_TIN_TUC",
            "exact": true
          },
          {
            "name": "QuanLyKhaoSat",
            "path": "/quanlytuongtac/quanlykhaosat",
            "access": "routeFilter",
            "maChucNang": "QUAN_LY_KHAO_SAT",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyKhaoSat' */'/usr/src/app/src/pages/QuanLyKhaoSat'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "HoatDongNgoaiKhoa",
            "path": "/quanlytuongtac/hoatdongngoaikhoa",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HoatDongNgoaiKhoa' */'/usr/src/app/src/pages/HoatDongNgoaiKhoa'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "HOAT_DONG_NGOAI_KHOA",
            "exact": true
          },
          {
            "hideInMenu": true,
            "exact": true,
            "path": "/quanlytuongtac/hoatdongngoaikhoa/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HoatDongNgoaiKhoa__$id' */'/usr/src/app/src/pages/HoatDongNgoaiKhoa/$id'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "DS_LOP_HOAT_DONG_NGOAI_KHOA"
          },
          {
            "name": "QuanLyDon",
            "path": "/quanlytuongtac/quanlydon",
            "access": "routeFilter",
            "maChucNang": "QUAN_LY_DON",
            "routes": [
              {
                "name": "DonXinNghiHoc",
                "icon": "table",
                "path": "/quanlytuongtac/quanlydon/donxinnghihoc",
                "access": "routeFilter",
                "maChucNang": "DON_XIN_NGHI_HOC",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDon__DonXinNghi' */'/usr/src/app/src/pages/QuanLyDon/DonXinNghi'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "DonDanDonVe",
                "icon": "table",
                "path": "/quanlytuongtac/quanlydon/dondandonve",
                "access": "routeFilter",
                "maChucNang": "DON_DAN_DON_VE",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDon__DanDonVe' */'/usr/src/app/src/pages/QuanLyDon/DanDonVe'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "DonDanThuoc",
                "icon": "table",
                "path": "/quanlytuongtac/quanlydon/dondanthuoc",
                "access": "routeFilter",
                "maChucNang": "DON_DAN_THUOC",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDon__DonDanThuoc' */'/usr/src/app/src/pages/QuanLyDon/DonDanThuoc'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "LoiDanCuaPhuHuynh",
                "icon": "table",
                "path": "/quanlytuongtac/quanlydon/loinhancuaphuhuynh",
                "access": "routeFilter",
                "maChucNang": "LOI_NHAN_PHU_HUYNH",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDon__LoiDanCuaPhuHuynh' */'/usr/src/app/src/pages/QuanLyDon/LoiDanCuaPhuHuynh'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "icon": "schedule",
        "path": "/danhgiagiaovien/:id",
        "access": "routeFilter",
        "maChucNang": "DANH_SACH_GIAO_VIEN_DANH_GIA",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDanhGia__DanhGiaGiaoVien__$id' */'/usr/src/app/src/pages/QuanLyDanhGia/DanhGiaGiaoVien/$id'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "icon": "schedule",
        "path": "/danhgiadinhkyhocsinh/:id",
        "access": "routeFilter",
        "maChucNang": "DANH_SACH_HOC_SINH_DANH_GIA",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDanhGia__DanhGiaHocSinh__$id' */'/usr/src/app/src/pages/QuanLyDanhGia/DanhGiaHocSinh/$id'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "QuanLyLichHoc",
        "icon": "solution",
        "path": "/quanlylichhoc",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_LICH_HOC",
        "routes": [
          {
            "name": "LichHoc",
            "icon": "table",
            "path": "/quanlylichhoc/lichhoc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyLichHoc' */'/usr/src/app/src/pages/QuanLyLichHoc'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "LICH_HOC",
            "exact": true
          },
          {
            "name": "LichHoc.Template",
            "icon": "table",
            "path": "/quanlylichhoc/lichhoctemplate",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTemplateLichHoc' */'/usr/src/app/src/pages/QuanLyTemplateLichHoc'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TEMPLATE_LICH_HOC",
            "exact": true
          },
          {
            "name": "ThongTinDaoTao",
            "icon": "team",
            "path": "/quanlylichhoc/thongtindaotao",
            "access": "routeFilter",
            "maChucNang": "THONG_TIN_DAO_TAO",
            "routes": [
              {
                "name": "PhuongPhapGiaoDuc",
                "icon": "team",
                "path": "/quanlylichhoc/thongtindaotao/phuongphapgiaoduc",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ChuongTrinhDaoTao' */'/usr/src/app/src/pages/ChuongTrinhDaoTao'), loading: LoadingComponent}),
                "access": "routeFilter",
                "maChucNang": "PHUONG_PHAP_GIAO_DUC",
                "exact": true
              },
              {
                "name": "LinhVucPhatTrien",
                "icon": "FileDoneOutlined",
                "path": "/quanlylichhoc/thongtindaotao/linhvucphattrien",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyMonHoc' */'/usr/src/app/src/pages/QuanLyMonHoc'), loading: LoadingComponent}),
                "access": "routeFilter",
                "maChucNang": "LINH_VUC_PHAT_TRIEN",
                "exact": true
              },
              {
                "name": "QuanLyBaiHoc",
                "icon": "table",
                "path": "/quanlylichhoc/thongtindaotao/quanlybaihoc",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyBaiHoc' */'/usr/src/app/src/pages/QuanLyBaiHoc'), loading: LoadingComponent}),
                "access": "routeFilter",
                "maChucNang": "QUAN_LY_BAI_HOC",
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "name": "NangCapTaiKhoan",
        "icon": "upload",
        "path": "/nangcaptaikhoan",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NangCapTaiKhoan' */'/usr/src/app/src/pages/NangCapTaiKhoan'), loading: LoadingComponent}),
        "access": "routeFilter",
        "maChucNang": "NANG_CAP_TAI_KHOAN",
        "exact": true
      },
      {
        "name": "NangCapTaiKhoan",
        "icon": "upload",
        "path": "/nangcaptaikhoan",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NangCapTaiKhoan' */'/usr/src/app/src/pages/NangCapTaiKhoan'), loading: LoadingComponent}),
        "access": "routeFilter",
        "maChucNang": "NANG_CAP_TAI_KHOAN_PH",
        "exact": true
      },
      {
        "name": "KhaiBaoThongTin",
        "icon": "user",
        "path": "/khaibaothongtin",
        "access": "routeFilter",
        "maChucNang": "KHAI_BAO_THONG_TIN",
        "routes": [
          {
            "name": "ThongTinCaNhan",
            "icon": "table",
            "path": "/khaibaothongtin/thongtincanhan",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KhaiBaoThongTin' */'/usr/src/app/src/pages/KhaiBaoThongTin'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "THONG_TIN_CA_NHAN",
            "exact": true
          },
          {
            "name": "ThongTinCon",
            "icon": "table",
            "path": "/khaibaothongtin/thongtincon",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KhaiBaoThongTin__components__ThongTinCon' */'/usr/src/app/src/pages/KhaiBaoThongTin/components/ThongTinCon.tsx'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "THONG_TIN_CON",
            "exact": true
          }
        ]
      },
      {
        "name": "ChucNangPhuHuynh",
        "icon": "profile",
        "path": "/chucnangphuhuynh",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ChucNangPhuHuynh' */'/usr/src/app/src/pages/ChucNangPhuHuynh'), loading: LoadingComponent}),
        "access": "routeFilter",
        "maChucNang": "CHUC_NANG_PHU_HUYNH",
        "exact": true
      },
      {
        "name": "QuanLyThucPham",
        "icon": "shop",
        "path": "/quanlythucpham",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_THUC_PHAM",
        "routes": [
          {
            "name": "DanhMucThucPham",
            "path": "/quanlythucpham/danhmucthucpham",
            "access": "routeFilter",
            "maChucNang": "DANH_MUC_THUC_PHAM",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__DanhMucThucPham' */'/usr/src/app/src/pages/ThucPham/DanhMucThucPham'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "QuanLyNhaCungCap",
            "path": "/quanlythucpham/quanlynhacungcap",
            "access": "routeFilter",
            "maChucNang": "QUAN_LY_NHA_CUNG_CAP",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__QuanLyNhaCungCap' */'/usr/src/app/src/pages/ThucPham/QuanLyNhaCungCap'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "DanhMucMonAn",
            "path": "/quanlythucpham/danhmucmonan",
            "access": "routeFilter",
            "maChucNang": "DANH_MUC_MON_AN",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__DanhMucMonAn' */'/usr/src/app/src/pages/ThucPham/DanhMucMonAn'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "QuyDoi",
            "path": "/quanlythucpham/quydoi",
            "access": "routeFilter",
            "maChucNang": "QUY_DOI",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuyDoi' */'/usr/src/app/src/pages/QuyDoi'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "ThucPhamKho",
            "path": "/quanlythucpham/thucphamkho",
            "access": "routeFilter",
            "maChucNang": "THUC_PHAM_KHO",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__ThucPhamKho' */'/usr/src/app/src/pages/ThucPham/ThucPhamKho'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "QuyDinhChung",
            "path": "/quanlythucpham/quydinhchung",
            "access": "routeFilter",
            "maChucNang": "QUY_DINH_CHUNG",
            "routes": [
              {
                "name": "QuyDinhChung",
                "path": "/quanlythucpham/quydinhchung/quydinhchung",
                "access": "routeFilter",
                "maChucNang": "QUY_DINH_CHUNG",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__QuyDinhChung' */'/usr/src/app/src/pages/ThucPham/QuyDinhChung'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "BangDinhDuong",
                "path": "/quanlythucpham/quydinhchung/quydinhdinhduong",
                "access": "routeFilter",
                "maChucNang": "BANG_DINH_DUONG",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__BangDinhDuong' */'/usr/src/app/src/pages/ThucPham/BangDinhDuong'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "QuyDinhThucDon",
                "path": "/quanlythucpham/quydinhchung/quydinhthucdon",
                "access": "routeFilter",
                "maChucNang": "QUY_DINH_THUC_DON",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__QuyDinhThucDon' */'/usr/src/app/src/pages/ThucPham/QuyDinhThucDon'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "KhauPhanAn",
            "path": "/quanlythucpham/khauphanan",
            "access": "routeFilter",
            "maChucNang": "KHAU_PHAN_AN",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__KhauPhanAn' */'/usr/src/app/src/pages/ThucPham/KhauPhanAn'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "LenThucDonMau",
            "path": "/quanlythucpham/lenthucdonmau",
            "access": "routeFilter",
            "maChucNang": "LEN_THUC_DON_MAU",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__LenThucDonMau' */'/usr/src/app/src/pages/ThucPham/LenThucDonMau'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "BaoCao",
            "path": "/quanlythucpham/baocaothucpham",
            "access": "routeFilter",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__BaoCao' */'/usr/src/app/src/pages/ThucPham/BaoCao'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "ThucDonVaLichHocAnh",
        "icon": "FileImageOutlined",
        "path": "/thuc-don-lich-hoc-anh",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_TAI_SAN",
        "routes": [
          {
            "name": "ThucDonAnh",
            "icon": "table",
            "path": "/thuc-don-lich-hoc-anh/thuc-don",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucDonVaLichHocAnh__ThucDon' */'/usr/src/app/src/pages/ThucDonVaLichHocAnh/ThucDon'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "DANH_MUC_TAI_SAN",
            "exact": true
          },
          {
            "name": "LichHocAnh",
            "icon": "table",
            "path": "/thuc-don-lich-hoc-anh/lich-hoc",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucDonVaLichHocAnh__LichHoc' */'/usr/src/app/src/pages/ThucDonVaLichHocAnh/LichHoc'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "BAO_HONG",
            "exact": true
          }
        ]
      },
      {
        "name": "CloneMenu",
        "path": "/clone-menu",
        "icon": "TableOutlined",
        "access": "routeFilter",
        "maChucNang": "CLONE_MENU_SCHOOL",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThucPham__CloneMenu' */'/usr/src/app/src/pages/ThucPham/CloneMenu'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "ThongBao",
        "icon": "notification",
        "path": "/thongbao",
        "access": "routeFilter",
        "maChucNang": "THONG_BAO",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThongBao' */'/usr/src/app/src/pages/ThongBao'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "AlbumAnh",
        "icon": "FileImageOutlined",
        "path": "/album-anh",
        "access": "routeFilter",
        "maChucNang": "ALBUM_ANH",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AlbumAnh' */'/usr/src/app/src/pages/AlbumAnh'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "DungLuongAlbumAnh",
        "icon": "FileImageOutlined",
        "path": "/dung-luong-album-anh",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_DUNG_LUONG_ALBUM_ANH",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DungLuongAlbumAnh' */'/usr/src/app/src/pages/DungLuongAlbumAnh'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "QuanLyGiaoVien",
        "icon": "EditFilled",
        "path": "/quanlygiaovien",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_GIAO_VIEN",
        "routes": [
          {
            "name": "Thông tin lương",
            "path": "/quanlygiaovien/hosogiaovien",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyLuongGiaoVien__ThongTinLuongGiaoVien' */'/usr/src/app/src/pages/QuanLyLuongGiaoVien/ThongTinLuongGiaoVien'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "HO_SO_GIAO_VIEN",
            "exact": true
          },
          {
            "name": "Quản lý hồ sơ giáo viên chi tiết",
            "path": "/quanlygiaovien/hosogiaovien/:id",
            "hideInMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanGiaoVien__$id' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanGiaoVien/$id'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "HO_SO_GIAO_VIEN",
            "exact": true
          },
          {
            "name": "DiemDanhGiaoVien",
            "path": "/quanlygiaovien/diemdanhgiaovien",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDiemDanh__DiemDanhGiaoVien' */'/usr/src/app/src/pages/QuanLyDiemDanh/DiemDanhGiaoVien'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "DIEM_DANH_GIAO_VIEN",
            "exact": true
          },
          {
            "name": "ThongKeLuong",
            "path": "/quanlygiaovien/thongkeluong",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThongKeLuong' */'/usr/src/app/src/pages/ThongKeLuong'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "THONG_KE_LUONG",
            "exact": true
          },
          {
            "name": "QuanLyThuBay",
            "path": "/quanlygiaovien/quanlythubay",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyThuBay' */'/usr/src/app/src/pages/QuanLyThuBay'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "HO_SO_GIAO_VIEN",
            "exact": true
          },
          {
            "name": "DanhGiaGiaoVien",
            "path": "/quanlygiaovien/danhgiagiaovien",
            "access": "routeFilter",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDanhGia__DanhGiaGiaoVien' */'/usr/src/app/src/pages/QuanLyDanhGia/DanhGiaGiaoVien'), loading: LoadingComponent}),
            "maChucNang": "DANH_GIA_GIAO_VIEN",
            "exact": true
          }
        ]
      },
      {
        "name": "QuanLyHocSinh",
        "icon": "CopyFilled",
        "path": "/quanlyhocsinh",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_HOC_SINH",
        "routes": [
          {
            "name": "ThongTinHocSinh",
            "path": "/quanlyhocsinh/thongtinhocsinh",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThongTinHocSinh' */'/usr/src/app/src/pages/ThongTinHocSinh'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "THONG_TIN_HOC_SINH",
            "exact": true
          },
          {
            "name": "ThongTinHocPhi",
            "path": "/quanlyhocsinh/thongtinhocphi",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThongTinHocPhi' */'/usr/src/app/src/pages/ThongTinHocPhi'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "HOC_PHI",
            "exact": true
          },
          {
            "hideInMenu": true,
            "exact": true,
            "path": "/quanlyhocsinh/thongtinhocphi/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ThongTinHocPhi__$id' */'/usr/src/app/src/pages/ThongTinHocPhi/$id'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "HOC_PHI"
          },
          {
            "name": "QuanLyHocThuBay",
            "path": "/quanlyhocsinh/quanlyhocthubay",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyHocThuBay' */'/usr/src/app/src/pages/QuanLyHocThuBay'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "HOC_PHI",
            "exact": true
          },
          {
            "hideInMenu": true,
            "exact": true,
            "path": "/quanlyhocsinh/quanlyhocthubay/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyHocThuBay__$id' */'/usr/src/app/src/pages/QuanLyHocThuBay/$id'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "HOC_PHI"
          },
          {
            "name": "DanhGiaDinhKyHocSinh",
            "icon": "schedule",
            "path": "/quanlyhocsinh/danhgiadinhkyhocsinh",
            "access": "routeFilter",
            "maChucNang": "DANH_GIA_HOC_SINH",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDanhGia__DanhGiaHocSinh' */'/usr/src/app/src/pages/QuanLyDanhGia/DanhGiaHocSinh'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "QuanLyDiemDanh",
            "icon": "ordered-list",
            "path": "/quanlyhocsinh/quanlydiemdanh",
            "access": "routeFilter",
            "maChucNang": "QUAN_LY_DIEM_DANH",
            "routes": [
              {
                "name": "DiemDanh",
                "icon": "table",
                "path": "/quanlyhocsinh/quanlydiemdanh/diemdanh",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDiemDanh__DiemDanh' */'/usr/src/app/src/pages/QuanLyDiemDanh/DiemDanh'), loading: LoadingComponent}),
                "access": "routeFilter",
                "maChucNang": "DIEM_DANH",
                "exact": true
              },
              {
                "hideInMenu": true,
                "exact": true,
                "path": "/quanlyhocsinh/quanlydiemdanh/diemdanh/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDiemDanh__DiemDanh__$id' */'/usr/src/app/src/pages/QuanLyDiemDanh/DiemDanh/$id'), loading: LoadingComponent}),
                "access": "routeFilter",
                "maChucNang": "CHI_TIET_LOP_DIEM_DANH"
              },
              {
                "name": "DiemDanhMuon",
                "icon": "table",
                "path": "/quanlyhocsinh/quanlydiemdanh/diemdanhmuon",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDiemDanh__DiemDanhMuon' */'/usr/src/app/src/pages/QuanLyDiemDanh/DiemDanhMuon'), loading: LoadingComponent}),
                "access": "routeFilter",
                "maChucNang": "DIEM_DANH_MUON",
                "exact": true
              },
              {
                "name": "DiemDanhThuBay",
                "icon": "table",
                "path": "/quanlyhocsinh/quanlydiemdanh/diemdanhthubay",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDiemDanh__DiemDanhThuBay' */'/usr/src/app/src/pages/QuanLyDiemDanh/DiemDanhThuBay'), loading: LoadingComponent}),
                "access": "routeFilter",
                "maChucNang": "DIEM_DANH",
                "exact": true
              }
            ]
          },
          {
            "name": "MauDanhGia",
            "icon": "schedule",
            "path": "/quanlyhocsinh/maudanhgia",
            "access": "routeFilter",
            "maChucNang": "QUAN_LY_MAU_DANH_GIA",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyDanhGia__MauDanhGia' */'/usr/src/app/src/pages/QuanLyDanhGia/MauDanhGia'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "QuanLyBaoCao",
        "icon": "ContainerOutlined",
        "path": "/quanlybaocao",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_BAO_CAO",
        "routes": [
          {
            "name": "BaoCaoSBN",
            "path": "/quanlybaocao/baocaosobannganh",
            "access": "routeFilter",
            "maChucNang": "BAO_CAO_SBN",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyBaoCao__BaoCaoSBN' */'/usr/src/app/src/pages/QuanLyBaoCao/BaoCaoSBN'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "BaoCaoHeThong",
            "path": "/quanlybaocao/baocaohethong",
            "access": "routeFilter",
            "maChucNang": "BAO_CAO_HE_THONG",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyBaoCao__BaoCaoHeThong' */'/usr/src/app/src/pages/QuanLyBaoCao/BaoCaoHeThong'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "DoanhThu",
        "icon": "DollarOutlined",
        "path": "/doanhthu",
        "access": "routeFilter",
        "maChucNang": "DOANH_THU",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DoanhThu' */'/usr/src/app/src/pages/DoanhThu'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "QuanLyTaiSan",
        "icon": "MoneyCollectOutlined",
        "path": "/quanlytaisan",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_TAI_SAN",
        "routes": [
          {
            "name": "DanhMucTaiSan",
            "icon": "table",
            "path": "/quanlytaisan/danhmuctaisan",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiSan__DanhMucTaiSan' */'/usr/src/app/src/pages/QuanLyTaiSan/DanhMucTaiSan'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "DANH_MUC_TAI_SAN",
            "exact": true
          },
          {
            "name": "BaoHongSuaChua",
            "icon": "table",
            "path": "/quanlytaisan/baohongsuachua",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiSan__BaoHong' */'/usr/src/app/src/pages/QuanLyTaiSan/BaoHong'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "BAO_HONG",
            "exact": true
          }
        ]
      },
      {
        "name": "QuanLyTaiKhoan",
        "icon": "team",
        "path": "/quanlytaikhoan",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_TAI_KHOAN",
        "routes": [
          {
            "name": "TaiKhoanChuTruong",
            "path": "/quanlytaikhoan/taikhoanchutruong",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanChuTruong' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanChuTruong'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TAI_KHOAN_CHU_TRUONG",
            "exact": true
          },
          {
            "name": "TaiKhoanHieuTruong",
            "path": "/quanlytaikhoan/taikhoanhieutruong",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanHieuTruong' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanHieuTruong'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TAI_KHOAN_HIEU_TRUONG",
            "exact": true
          },
          {
            "name": "TaiKhoanGiaoVien",
            "path": "/quanlytaikhoan/taikhoangiaovien",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanGiaoVien' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanGiaoVien'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TAI_KHOAN_GIAO_VIEN",
            "exact": true
          },
          {
            "name": "TaiKhoanGiaoVien",
            "path": "/quanlytaikhoan/taikhoangiaovien/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanGiaoVien__$id' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanGiaoVien/$id'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TAI_KHOAN_GIAO_VIEN",
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "TaiKhoanPhuHuynh",
            "path": "/quanlytaikhoan/taikhoanphuhuynh",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanPhuHuynh' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanPhuHuynh'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TAI_KHOAN_PHU_HUYNH",
            "exact": true
          },
          {
            "name": "TaiKhoanPhuHuynh",
            "path": "/quanlytaikhoan/taikhoanphuhuynh/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanPhuHuynh__$id' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanPhuHuynh/$id'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TAI_KHOAN_PHU_HUYNH",
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "TaiKhoanKhach",
            "path": "/quanlytaikhoan/taikhoankhach",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanKhach' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanKhach'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TAI_KHOAN_KHACH",
            "exact": true
          },
          {
            "name": "TaiKhoanPhuHuynh",
            "path": "/quanlytaikhoan/taikhoankhach/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyTaiKhoan__TaiKhoanPhuHuynh__$id' */'/usr/src/app/src/pages/QuanLyTaiKhoan/TaiKhoanPhuHuynh/$id'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "TAI_KHOAN_KHACH",
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "name": "QuanTriPhanQuyen",
        "icon": "table",
        "path": "/quantriphanquyen",
        "access": "routeFilter",
        "maChucNang": "QUAN_TRI_PHAN_QUYEN",
        "routes": [
          {
            "name": "VaiTroQuanLy",
            "path": "/quantriphanquyen/vaitroquanly",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanTriPhanQuyen__VaiTroQuanTri' */'/usr/src/app/src/pages/QuanTriPhanQuyen/VaiTroQuanTri'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "VAI_TRO_QUAN_LY",
            "exact": true
          },
          {
            "name": "ChucNangQuanTri",
            "path": "/quantriphanquyen/chucnangquanly",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanTriPhanQuyen__ChucNangQuanTri' */'/usr/src/app/src/pages/QuanTriPhanQuyen/ChucNangQuanTri'), loading: LoadingComponent}),
            "access": "routeFilter",
            "maChucNang": "CHUC_NANG_QUAN_LY",
            "exact": true
          }
        ]
      },
      {
        "name": "QuanLyCamera",
        "icon": "video-camera",
        "path": "/quanlycamera",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_CAMERA",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyCamera' */'/usr/src/app/src/pages/QuanLyCamera'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "BaoCaoQuanTri",
        "icon": "table",
        "path": "/baocaoquantri",
        "access": "routeFilter",
        "maChucNang": "BAO_CAO_QUAN_TRI",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BaoCaoQuanTri' */'/usr/src/app/src/pages/BaoCaoQuanTri'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "QuanLyCauHinh",
        "icon": "setting",
        "path": "/quanlycauhinh",
        "access": "routeFilter",
        "maChucNang": "QUAN_LY_CAU_HINH",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuanLyCauHinh' */'/usr/src/app/src/pages/QuanLyCauHinh'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/usr/src/app/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
